import { notify } from "@/shared/utils/notify";
import {
  promotionRulesService,
  promotionRuleCategoriesService,
} from "../../../shared/services";

export const useUpdatePromotion = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const updateStatus = async (id: number, status: "active" | "inactive") => {
    try {
      await promotionRulesService.patch(id, { status });
      notify.success(
        status === "active" ? "Promoción activada" : "Promoción desactivada"
      );
      onSuccess?.();
    } catch (err: any) {
      notify.error(err.message || "Error al actualizar el estado");
    }
  };

  const removePromotion = async (id: number) => {
    try {
      await promotionRulesService.remove(id);
      notify.success("Promoción eliminada");
      onSuccess?.();
    } catch (err: any) {
      notify.error(err.message || "Error al eliminar la promoción");
    }
  };

  const addCategory = async (
    promotionRuleId: number,
    categoryId: number,
    role: "primary" | "secondary",
    requiredQuantity: number,
    position: number
  ) => {
    try {
      await promotionRuleCategoriesService.create({
        promotion_rule_id: promotionRuleId,
        category_id: categoryId,
        role,
        required_quantity: requiredQuantity,
        is_required: "true",
        position,
      });
      notify.success("Categoría agregada");
      onSuccess?.();
    } catch (err: any) {
      notify.error(err.message || "Error al agregar categoría");
    }
  };

  const removeCategory = async (id: number) => {
    try {
      await promotionRuleCategoriesService.remove(id);
      notify.success("Categoría removida");
      onSuccess?.();
    } catch (err: any) {
      notify.error(err.message || "Error al remover categoría");
    }
  };

  const updateCategoryQuantity = async (id: number, quantity: number) => {
    try {
      await promotionRuleCategoriesService.patch(id, {
        required_quantity: quantity,
      });
      notify.success("Cantidad actualizada");
      onSuccess?.();
    } catch (err: any) {
      notify.error(err.message || "Error al actualizar cantidad");
    }
  };

  return {
    updateStatus,
    removePromotion,
    addCategory,
    removeCategory,
    updateCategoryQuantity,
  };
};
